module.exports = "/_next/static/images/faceVerify-ef1b0698b57c69e1921535979f5c474a.svg";